export default __webpack_public_path__ + "static/media/vaccin.1ad67e7d.jpg";